const LimitLicense = () =>
  import(
    /* webpackChunkName: "security-limit-license" */ '@/pages/security/limit-license/index.vue'
  )
const CreateLimitLicense = () =>
  import(
    /* webpackChunkName: "security-limit-license" */ '@/pages/security/limit-license/create.vue'
  )
const EditLimitLicense = () =>
  import(
    /* webpackChunkName: "security-limit-license" */ '@/pages/security/limit-license/edit.vue'
  )

export default {
  path: 'limit-license',
  meta: {
    label: 'limitLicense',
    auth: 'licenseLimit'
  },
  component: {
    name: 'Limit',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityLimitLicenseReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: LimitLicense
    },
    {
      name: 'SecurityCreateLimitLicense',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLimitLicense
    },
    {
      name: 'SecurityEditLimitLicense',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLimitLicense,
      props: true
    }
  ]
}
